<nz-card
		*ngFor="let reportConfig of usedReportConfigs"
		nzTitle="{{ reportConfig.label }}"
		[hidden]="isCardHidden || (!reportConfig.visible && !reportConfig.printable)"
		[ngClass]="{
		'print-hide': reportConfig.visible && !reportConfig.printable,
		'print-only': !reportConfig.visible && reportConfig.printable,
		'd-none': !reportConfig.visible && !reportConfig.printable}"
		class="print-no-header print-no-padding print-no-border print-no-shadow mb-3"
>
	<div class="card-body">
		<div class="print-only print-page-break-after titlepage" *ngIf="reportConfig.title">
			<div markdown>{{reportConfig.title}}</div>
		</div>
		<table class="print-table" *ngFor="let category of reportConfig.categories; let i = index; let first = first; let last = last"
				[style]="category.options?.printConfig?.forcePageBreak ? 'page-break-before: always' : ''">
			<thead class="print-only" *ngIf="reportConfig.header && (category.options?.printConfig?.forcePageBreak || first)">
				<tr>
					<th>
						<div class="header-space">&nbsp;</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						<div markdown>{{reportConfig.description}}</div>
					</td>
				</tr>
				<tr class="print-page-inside-avoid">
					<td>
						<workflow-report *ngIf="reportData"
								[reports]="reportConfig.reports"
								[data]="reportData"
								[category]="category"
						>
						</workflow-report>
					</td>
				</tr>
			</tbody>
			<tfoot class="print-only" *ngIf="reportConfig.footer && (reportConfig.categories[i+1]?.options?.printConfig?.forcePageBreak || last)">
				<tr>
					<td>
						<div class="footer-space">&nbsp;</div>
					</td>
				</tr>
			</tfoot>
		</table>
		<div class="print-header" markdown *ngIf="reportConfig.header">{{ reportConfig.header }}</div>
		<div class="print-footer" markdown *ngIf="reportConfig.footer">{{ reportConfig.footer }}</div>
	</div>
</nz-card>
